import React from 'react';
import { JiraIssueTypeData } from '../../../../api/endpoints/jira';
import { MenuButton } from '../../../../ui/MenuButton';
import { useJiraSelectorOnSelect } from './JiraMenuHooks';
import { JiraProjectIssueTypeMenu } from './JiraProjectIssueTypeMenu';

export type JiraIssueTypeSelectorProps = {
    jiraProjectId: string,
    selected: JiraIssueTypeData[],
    onChange(selected: JiraIssueTypeData[]): void,
};

export const JiraProjectIssueTypeSelector = ({ jiraProjectId, selected, onChange }: JiraIssueTypeSelectorProps) => {

    const label = selected.map(x => x.name).join(', ') || 'Issue Type';
    const onSelect = useJiraSelectorOnSelect(selected, onChange);

    return <MenuButton block label={label}>
        <JiraProjectIssueTypeMenu jiraProjectId={jiraProjectId} selected={selected} multi onSelect={onSelect} />
    </MenuButton>;
};
